import { BackTop, BackTopProps } from "antd";
import { MyColor } from "../config/myStyle";
import { back_to_top_button } from "../imgs";

export const MyBackTop = (props: BackTopProps) => {

  return (
    <BackTop
      visibilityHeight={150}
      style={{
        zIndex:1000,
      }}
    >
      <div className="flex" style={{
        height: 48, width: 48, background: MyColor.primary,
        color: '#fff', borderRadius: '50%', textAlign: 'center',
        lineHeight: '48px', boxShadow: '0 2px 8px #d7d7d7',
      }}>
        <img
          src={back_to_top_button}
          className="h-[48px] w-[48px]" />
      </div>
    </BackTop>
  )
}